import NoticesService from 'src/services/notices'

export default {
  createNotice (payload) {
    const promise = NoticesService.createNotice(payload)

    promise
      .then((notice) => {
        if (notice) {
          const noticeWithAuthor = {
            ...notice,
            author: notice.author || {
              id: payload.created_by,
              name: 'Usuario actual'
            },
            is_read: false
          }

          this.notices.unshift(noticeWithAuthor)
          this.total = (this.total || 0) + 1

          if (notice.status === 'scheduled') {
            this.scheduleds = (this.scheduleds || 0) + 1
          } else if (notice.status === 'published') {
            this.unread = (this.unread || 0) + 1
          }
        }
      })
      .catch((err) => {
        console.error('Error en createNotice:', err)
      })

    return promise
  },
  fetchNotices (is_admin = false, limit_by = null) {
    const isHomeFetch = !is_admin && limit_by === 5

    if (isHomeFetch && this.homeFetched) {
      return Promise.resolve()
    }

    const promise = NoticesService.fetchNotices(is_admin, limit_by)

    promise
      .then(data => {
        this.read = data.counters.read
        this.unread = data.counters.unread
        this.total = data.counters.total
        this.scheduleds = data.counters.scheduleds ?? 0
        this.notices = data.data

        if (isHomeFetch) {
          this.homeFetched = true
        } else {
          this.homeFetched = false
        }
      })
      .catch((err) => {
        console.error('Error en fetchNotices:', err)
      })

    return promise
  },
  deleteNotice (id) {
    const promise = NoticesService.deleteNotice(id)

    promise
      .then(() => {
        this.notices = this.notices.filter(n => n.id !== id)
        this.total = Math.max((this.total || 1) - 1, 0)
      })
      .catch((err) => {
        console.error('Error en deleteNotice:', err)
      })

    return promise
  },
  fetchNotice (id) {
    return NoticesService.fetchNotice(id)
  },
  updateNotice (id, payload) {
    const promise = NoticesService.updateNotice(id, payload)

    promise
      .then((notice) => {
        const index = this.notices.findIndex(n => n.id === id)
        if (index !== -1) {
          // Conserva is_read/author del listado: la respuesta del PUT no los trae.
          this.notices.splice(index, 1, { ...this.notices[index], ...notice })
        }
      })
      .catch((err) => {
        console.error('Error en updateNotice:', err)
      })

    return promise
  },
  fetchAudienceRoles () {
    return NoticesService.fetchAudienceRoles()
  },
  fetchAudienceLocations (params) {
    return NoticesService.fetchAudienceLocations(params)
  },
  uploadEditorImage (file) {
    return NoticesService.uploadEditorImage(file)
  },
  markAsRead (id) {
    const promise = NoticesService.markAsRead(id)

    promise
      .then(() => {
        const notice = this.notices.find(n => n.id === id)
        if (notice && !notice.is_read) {
          notice.is_read = true
        }
      })
      .catch((err) => {
        console.error('Error en markAsRead:', err)
      })

    return promise
  }
}
